'use client'
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import Image from "next/image";
import BannerImpact from '../banner/banner';
import impactBlackLogo from '@/app/assets/images/black-logo-impact-network.svg'
import React from 'react';
import { X } from 'lucide-react';
import lbsHand from '../../../assets/images/logo.svg';
import Link from 'next/link';

const labelsNames = [
    'impact-home-card-1',
    'impact-home-card-2',
    'impact-home-card-3',
    'impact-home-card-4',
    'impact-home-card-5',
    'impact-home-card-6',
    'impact-home-card-7',
    'impact-home-card-8',
]

export default function ImpactHomeCard({
    labels,
    lang,
  }: {
    labels: any;
    lang: any;
  }) {

    const [showBanner, setShowBanner] = useState(false);
    const [canDownload, setCanDownload] = useState(false);

    useEffect(() => {
        setCanDownload(Boolean(localStorage.getItem('user')));
    }, []);

    const handleDownloadClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (!canDownload) {
            e.preventDefault(); // Evitamos que se descargue el archivo
            setShowBanner(true); // Mostramos el banner
        }
    };

    const handleCloseBanner = () => {
        setShowBanner(false); // Ocultamos el banner cuando el usuario lo cierre
    };

    const imageSrc = `${process.env.URL}/images/web/impact-home-card.jpg`;

    return (
        <div className="max-w-screen-xl mx-auto">
            <div className="bg-[#FDF6F1] rounded-3xl relative shadow-md shadow-slate-400 my-12 mx-8">
                <div className='flex justify-between items-center'>
                    <div className='flex flex-col items-start justify-between w-full h-full px-4 gap-y-3 md:gap-y-6'>
                        <div className='text-orange-custom text-3xl font-semibold'>
                            {labels.impactHomeCard1}
                        </div>
                        <div className='text-base font-medium'>
                            {labels.impactHomeCard2}
                        </div>
                        <Button variant={'defaultRounded'} className='px-8'>
                            <a href='\files\guia-inversor-de-impacto.pdf' target='_blank' onClick={handleDownloadClick}>
                                {labels.impactHomeCard3}
                            </a>
                        </Button>
                    </div>
                    <div className='sm:w-96 w-0 h-[300px] md:h-[230px] bg-cover bg-center rounded-r-3xl sm:visible invisible' style={{ backgroundImage: `url(${imageSrc})`, backgroundSize: '150%', backgroundPosition: 'right bottom' }}></div>
                </div>
            </div>

            {/* Mostramos el banner si showBanner es true */}
            {showBanner ?
                <>
                    <div className="fixed inset-0 flex items-center justify-center px-4 z-40">
                        <div className="max-w-[1200px] w-full h-auto px-6 py-6 rounded-2xl shadow-md relative mx-auto z-50 bg-white border">

                            <button className="absolute top-0 right-0 rounded-full bg-lbs-secondary-orange text-black p-2" onClick={() => setShowBanner(false)}>
                                <X size={18} />
                            </button>
                            <img className='absolute top-80 left-20 min-[800px]:top-8 min-[800px]:left-14 w-32 z-30' src='/images/LBS-hand-primary.png'/>

                            <div className="flex flex-col items-center justify-center gap-4 z-40">
                                <h3 className='text-4xl md:ml-36 py-4 z-40'>
                                    {/* {labels.impactHomeCard4} */}
                                    {lang === 'en' 
                                        ? <>Guide for <span className='text-primary font-semibold'>Impact</span> <span className='text-primary font-semibold'>Investors</span></> 
                                        : <>Guía para el <span className='text-primary font-semibold'>Inversor</span> de <span className='text-primary font-semibold'>Impacto</span></>}
                                </h3>
                                <div className='h-auto border-4 border-primary bg-[#fff8f1] rounded-3xl w-[100%] md:w-[90%] p-4 flex flex-col items-center z-40'>
                                    <h3 className='font-black py-2 px-2 text-2xl min-[700px]:text-3xl min-[800px]:text-4xl'>
                                        {labels.impactHomeCard5}
                                    </h3>
                                    <div className='flex flex-col min-[900px]:flex-row items-center justify-center h-full'>
                                        <div className='w-full min-[900px]:w-2/4 h-[80%]'>
                                            <img src="/images/banner-actualidad-de-impacto-LBS.png" className='w-[95%] rounded-full' />
                                        </div>
                                        <div className='w-full min-[900px]:w-2/4 h-full p-4 flex flex-col'>
                                            <p className='text-xl font-medium px-2 md:px-4'>
                                                {/* {labels.impactHomeCard6} */}
                                                {lang === 'en' 
                                                    ? <>Get access to our complete guide <span className='font-black'>&quot;Recommendations to Avoid Impact Washing&quot;</span>, specially designed for investors committed to real social and environmental impact.</> 
                                                    : <>Obtén acceso a nuestra completa guía <span className='font-black'>&quot;Recomendaciones para evitar el impact Washing&quot;</span>, diseñada especialmente para inversores comprometidos con el impacto social y ambiental real.</>}
                                            </p>
                                            <div className='flex flex-col md:flex-row w-full justify-center gap-4 md:gap-12'>
                                                <Link href={"https://www.goparity.com/es"} target="_blank" rel="noopener noreferrer">
                                                    <Button variant={'impactBlack'} className="md:mt-6 mt-2 px-6 py-[10px] font-normal rounded-full bg-lbs-secondary-orange text-white hover:bg-white hover:text-primary hover:border hover:border-primary transition">
                                                        {labels.impactHomeCard7}
                                                    </Button>
                                                </Link>
                                                <Link href={"https://www.goparity.com/es"} target="_blank" rel="noopener noreferrer">
                                                    <Button variant={'impactBlack'} className="md:mt-6 px-6 py-[10px] font-normal rounded-full bg-white text-primary border border-primary hover:bg-orange-600 hover:text-white transition">
                                                        {labels.impactHomeCard8}
                                                    </Button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>

                </>
                : <></>
            }
        </div>
    );
}
